<div class="auth-shell">
  <app-auth-showcase></app-auth-showcase>

  <section class="auth-panel">
    <div class="auth-panel__card">
      <div class="auth-panel__switch">
        <app-language-switch></app-language-switch>
      </div>

      <div class="auth-panel__header">
        <h2>{{ 'signIn.title' | t }}</h2>
        <p>{{ isBangla ? 'আপনার অ্যাকাউন্টে লগইন করুন' : 'Sign in to your account' }}</p>
      </div>

      <form #signInForm (ngSubmit)="login()" class="auth-form" novalidate autocomplete="on" method="post">
        <div class="form-group">
          <input id="sign-in-email" type="email" name="email" [(ngModel)]="credentials.email"
            [placeholder]="'signIn.emailPlaceholder' | t" autocomplete="username email" autocapitalize="none"
            spellcheck="false" required />
        </div>

        <div class="form-group">
          <input id="sign-in-password" type="password" name="password" [(ngModel)]="credentials.password"
            [placeholder]="'signIn.passwordPlaceholder' | t" autocomplete="current-password" required />
        </div>

        <div class="auth-form__meta">
          <label class="remember-checkbox">
            <input type="checkbox" name="rememberMe" [(ngModel)]="rememberMe" />
            <span>{{ 'signIn.rememberMe' | t:'Remember me' }}</span>
          </label>

          <button type="button" class="forgot-password-btn" (click)="openForgotPasswordModal()">
            {{ 'signIn.forgotPassword' | t }}
          </button>
        </div>

        <button type="submit" [disabled]="isLoading" class="submit-btn">
          {{ isLoading ? ('signIn.processing' | t) : ('signIn.submit' | t) }}
        </button>
      </form>

      <div class="auth-divider">
        <span>{{ isBangla ? 'অথবা' : 'Or' }}</span>
      </div>

      <div class="login-link login-link--boxed">
        <span>{{ 'signIn.newTo' | t }}</span>
        <a routerLink="/signUp">{{ 'signIn.signUp' | t }}</a>
      </div>

      <div class="auth-role-card">
        <div class="auth-role-card__title">{{ localize(rolesHeading) }}</div>
        <div class="auth-role-card__list">
          @for (role of roles; track role.text.en) {
          <div class="auth-role-card__item">
            <span class="auth-role-card__icon" [innerHTML]="role.icon"></span>
            <span class="auth-role-card__label">{{ localize(role.text) }}</span>
            @if (roleHelpSegments(role).length) {
            <span class="auth-role-help">
              <button
                type="button"
                class="auth-role-help__trigger"
                [attr.aria-label]="localize(role.text) + ' help'"
              >?</button>
              <span class="auth-role-help__bubble">
                @for (segment of roleHelpSegments(role); track $index) {
                <span [class.auth-role-help__keyword]="segment.isKeyword">{{ segment.text }}</span>
                }
              </span>
            </span>
            }
          </div>
          }
        </div>
      </div>

      <div class="message error" *ngIf="error">{{ error }}</div>
      <div class="message success" *ngIf="status">{{ status }}</div>
    </div>
  </section>
</div>

<div class="modal-overlay" *ngIf="isForgotPasswordModalOpen" (click)="closeForgotPasswordModal()">
  <div class="forgot-password-modal" (click)="$event.stopPropagation()">
    <button type="button" class="close-icon" aria-label="Close"
      (click)="closeForgotPasswordModal($event)">&times;</button>
    <h3>{{ 'signIn.forgot.title' | t }}</h3>
    <p class="forgot-password-copy">{{ 'signIn.forgot.copy' | t }}</p>

    <div class="forgot-password-grid">
      <label class="forgot-password-field forgot-password-field-wide">
        <span>{{ 'signIn.forgot.email' | t }}</span>
        <input type="email" [(ngModel)]="resetForm.email" [placeholder]="'signIn.forgot.emailPlaceholder' | t"
          autocomplete="email" />
      </label>

      <div class="forgot-password-actions-inline">
        <button type="button" class="forgot-password-send-btn" [disabled]="isSendingResetOtp"
          (click)="sendPasswordResetOtp()">
          {{ isSendingResetOtp ? ('signIn.forgot.sending' | t) : (isResetOtpSent ? ('signIn.forgot.resendOtp' | t) :
          ('signIn.forgot.sendOtp' | t)) }}
        </button>
      </div>

      <label class="forgot-password-field">
        <span>{{ 'signIn.forgot.otp' | t }}</span>
        <input type="text" [(ngModel)]="resetForm.otp" [placeholder]="'signIn.forgot.otpPlaceholder' | t"
          autocomplete="one-time-code" inputmode="numeric" />
        <div class="forgot-password-otp-meta" *ngIf="isResetOtpSent && resetOtpExpiresInSeconds > 0">
          {{ 'signIn.forgot.otpExpiresIn' | t }} {{ resetOtpExpireLabel }}
        </div>
        <div class="forgot-password-otp-meta expired" *ngIf="isResetOtpSent && resetOtpExpiresInSeconds === 0">
          {{ 'signIn.forgot.otpExpired' | t }}
        </div>
      </label>

      <label class="forgot-password-field">
        <span>{{ 'signIn.forgot.newPassword' | t }}</span>
        <input type="password" [(ngModel)]="resetForm.newPassword"
          [placeholder]="'signIn.forgot.newPasswordPlaceholder' | t" autocomplete="new-password" />
      </label>

      <label class="forgot-password-field forgot-password-field-wide">
        <span>{{ 'signIn.forgot.confirmPassword' | t }}</span>
        <input type="password" [(ngModel)]="resetForm.confirmPassword"
          [placeholder]="'signIn.forgot.confirmPasswordPlaceholder' | t" autocomplete="new-password" />
      </label>
    </div>

    <div class="forgot-password-footer">
      <button type="button" class="forgot-password-submit-btn" [disabled]="isResettingPassword"
        (click)="submitPasswordReset()">
        {{ isResettingPassword ? ('signIn.forgot.updating' | t) : ('signIn.forgot.submit' | t) }}
      </button>
    </div>

    <div class="message error" *ngIf="resetError">{{ resetError }}</div>
    <div class="message success" *ngIf="status">{{ status }}</div>
  </div>
</div>
